export default [
    {
        path: "add-stripe-payment-setting",
        name: "addstripepaymentsetting",
        component: () =>
            import(
                /* webpackChunkName: "AddSingleSubscriber" */ "../pages/stripePayment/AddStripePaymentSetting.vue"
            ),
        meta: {
            title: `Add Stripe Payment Setting`,
        },
    }
];
